import { $themeConfig } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    isVerticalMenuCollapsed: localStorage.getItem('menu-collapsed') ? localStorage.getItem('menu-collapsed') === 'true' : $themeConfig.layout.menu.isCollapsed,
  },
  getters: {},
  mutations: {
    UPDATE_VERTICAL_MENU_COLLAPSED(state, val) {
      state.isVerticalMenuCollapsed = val

      localStorage.setItem('menu-collapsed', val)
    },
  },
  actions: {},
}
